
import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import Header from './components/Header';
import HeroSection from './components/HeroSlider';
import Footer from './components/Footer';
import ContactSection from './pages/ContactSection';
import Enquiry from './pages/Enquiry';
import Career from './components/Career';
import Booking from './pages/Booking';
import Gallery from './pages/Gallery';
import TermsConditions from './components/TermsConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import Packages from './pages/Packages';
import AboutSection from './components/AboutSection';
import Services from './pages/Services';
import Ourfleets from './pages/Ourfleets';
import Punetomumbaiairportcab from './pages/Pune to Mumbai Airport Cab';
import ScrollToTop from './components/ScrollToTop';
import PuneToOutstationCabs from './pages/Pune to Outstation Cabs';
import Punetomahabaleshwarcab from './pages/Pune to Mahabaleshwar Cab';
import Punetolonavalacab from './pages/Pune to Lonavala Cab';
import Punetomatherancabs from './pages/Pune to Matheran Cabs';
import Punetofivejyotilingadarshan from './pages/Pune to 5 Jyotirlinga Darshan Cab';
import Punetobhimashankarcabs from './pages/Pune to Bhimashankar Cab';
import Punetoaurangabadcab from './pages/Pune to Aurangabad Cab Service';
import Punetonashikcabservice from './pages/Pune to Nashik Cab Service';
import Punetokolhapurcab from './pages/Pune to Kolhapur Cab Service';
import Punetoalibaugcab from './pages/Pune to Alibaug Cab';
import Punetogoacabservice from './pages/Pune to Goa Cab Service';
import Goatopunecab from './pages/Goa to Pune Cabs';
import Innovacrystacabinpune from './pages/Innova Crysta Cab in Pune';
import Punetoashtavinayakcabs from './pages/Pune to Ashtavinayak Cabs';
import Ertigaonrentinpune from './pages/Ertiga On Rent in Pune';
import Punetogoacabs from './pages/Pune to Goa Cabs';
import Punetojyotilingadarshanpackage from './pages/Pune to Jyotirlinga Darshan Package';
import Punetoakkalkotcabs from './pages/Pune to Akkalkot Cabs';
import Punetopandharpurcab from './pages/Pune to Pandharpur Cab';
import Punetogrishneshwarjyotilingacab from './pages/Pune to Grishneshwar Jyotirlinga Cab';
import Punetomumbaicabs from './pages/Pune to Mumbai Cabs';
import Innovacrystaonrentinpune from './pages/Innova Crysta On Rent in Pune';
import Ertigahireinpune from './pages/Ertiga Hire in Pune';
import Punetoshrivardhancab from './pages/Pune to Shrivardhan Cab';
import Punetojyotibacab from './pages/Pune to Jyotiba Cab';
import Punetoshirdicab from './pages/Pune to Shirdi Cab';
import Sedanacabservice from './pages/Sedan Cab Service';
import Hydundaixcentcabinpune from './pages/Hyundai Xcent Cabs in Pune';
import Swiftdzireonrentinpune from './pages/Swift Dzire On Rent in Pune';
import Auracabserviceinpune from './pages/Aura Cab Service in Pune';
import Punedarshansedancabbooking from './pages/Pune Darshan Sedan Cab Booking';
import Punetoayodhyatourpackage from './pages/Pune to Ayodhya Tour Package';
import Punetomahabaleshwarcabsedan from './pages/Pune to Mahabaleshwar Sedan Cab';
import Puneairportcabsedanservice from './pages/Pune Airport Cab Sedan Service';
import Punetoshirdisedancab from './pages/Pune to Shirdi Sedan Cabs';
import Sedancabbookingpune from './pages/Sedan Cab Booking Pune';
import Punehyundaiauracab from './pages/Pune Hyundai Aura Cab';
import Punetolonavalasedancab from './pages/Pune to Lonavala Sedan Cabs';
import Onlinesedancabbookingpune from './pages/Online Sedan Cab Booking Pune';
import Punetovidarbhacabservice from './pages/Pune to Vidarbha Cab Service';
import Punetohyderabadcab from './pages/Pune to Hyderabad Cab';
import Punetoujjaincab from './pages/Pune to Ujjain Cab';
import Corporatecabservicepune from './pages/Corporate Cab Service Pune';
import Punerailwaystationcabservice from './pages/Pune Railway Station Cab Service';
import Cheapcabserviceinpune from './pages/Cheap Cab Service in Pune';
import Onlinecabbookinpune from './pages/Online Cab Booking Pune';
import Punetobanglorecab from './pages/Pune to Bangalore Cab';
import Punetogujratcabservice from './pages/Pune to Gujarat Cab Service';
import Punetonagpurcab from './pages/Pune to Nagpur Cab';
import Punetoahmednagar from './pages/Pune to Ahmednagar Cab';
import Punetolaturcab from './pages/Pune to Latur Cab';
import Punetojalnacab from './pages/Pune to Jalna Cab';
import Punetomumbaidarshanca from './pages/Pune to Mumbai Darshan Cab';
import Punetosataracab from './pages/Pune to Satara Cab';
import Punetosanglicab from './pages/Pune to Sangli Cab';
import Punetosolapurcab from './pages/Pune to Solapur Cab';
import Puneairportcab from './pages/Pune Airport Cab';
import Punetorajshthancab from './pages/Pune to Rajasthan Cab';
import Punetosambhajinagarcab from './pages/Pune to Sambhajinagar Cab';
import Punetodhukecab from './pages/Pune to Dhule Cab';
import Punetotelganacab from './pages/Pune to Telangana Cab';
import Punetoindorecab from './pages/Pune to Indore Cab';
import Punetaxiservice from './pages/Pune Taxi Service';
import Bestcabserviceinpune from './pages/Best Cab Service in Pune';
import Puneonewaycabservice from './pages/Pune One Way Cab Service';
import Punelocalandoutstioncab from './pages/Pune Local and Outstation Cab';
import Punetojalgaoncab from './pages/Pune to Jalgaon Cab Service';
import Punetothanecab from './pages/Pune to Thane Cab';
import Punetopanvelcabs from './pages/Pune to Panvel Cabs';
import Punetonandedcabservice from './pages/Pune to Nanded Cab Service';
import Punetosuracab from './pages/Pune to Surat Cab';
import Punetoahmedabadcab from './pages/Pune to Ahmedabad Cab';
import Punetomahabaleshwartaxi from './pages/Pune to Mahabaleshwar Taxi';
import Punetolgatpuritaxi from './pages/Pune to Igatpuri Taxi';
import Punetotamhinighat from './pages/Pune to Tamhini Ghat Cab';
import Punetotrimbkeshwarcab from './pages/Pune to Trimbakeshwar Cab Service';
import Punetoashtavinayakdarshancab from './pages/Pune to Ashtavinayak Darshan Cab';
import Punetojejuricab from './pages/Pune to Jejuri Cab Service';
import Punetoaundhnagnathcab from './pages/Pune to Aundha Nagnath Cab';
import Punetokonkadarshancabn from './pages/Pune to Konkan Darshan Cab';
import Mumbaiairporttopunecab from './pages/Mumbai Airport to Pune Cab';
import Mumbaiairportcabservice from './pages/Mumbai Airport Cab Service';
import Navimumbaiairportcab from './pages/Navi Mumbai Airport Cab';
import Cabserviceinnavimumbai from './pages/Cab Service in Navi Mumbai';
import Innovacrystaonrentinmumbai from './pages/Innova Crysta On Rent in Mumbai';
import Ertigaonrentinmumbai from './pages/Ertiga On Rent in Mumbai';
import Mumbaitomahabaleshwarcab from './pages/Mumbai to Mahabaleshwar Cab';
import Cabserviceithene from './pages/Cab Service in Thane';
import Mumbaitogoacab from './pages/Mumbai to Goa Cab';
import Cabserviceinpimprichichwad from './pages/Cab Service in Pimpri Chinchwad';
import Puneinnovacabs from './pages/Pune Innova Cabs';
import Bestoutstationcabservice from './pages/Best Outstation Cab Service in Pune';
import Punetopanchganicab from './pages/Pune to Panchgani Cabs';
import Hinjewadicabservice from './pages/Hinjewadi Cab Service';
import Navimumbaiinternatinalairport from './pages/Navi Mumbai International Airport Cabs';
import Cabserviceinkharadi from './pages/Cab Service in Kharad';
import Cabserviceinwagholi from './pages/Cab Service in Wagholi';
import Cabserviceinmundhwa from './pages/Cab Service in Mundhwa';
import Cabserviceinkalyaninagar from './pages/Cab Service in Kalyani Nagar';
import Cabserviceinkothrud from './pages/Cab Service in Kothrud';
import ContactButtons from './components/ContactButtons';
import Blog from './pages/Blog';

function App() {
  return (
    <Router>
      <ContactButtons />
      <ScrollToTop />
<Header />
      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/contact-us" element={<ContactSection />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/about-us" element={<AboutSection />} />
        <Route path="/career" element={<Career />} />
        <Route path="/services" element={<Services />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/our-fleet" element={<Ourfleets />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/blogs" element={<Blog />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/pune-to-mumbai-airport-cab-service" element={<Punetomumbaiairportcab />} />


        <Route path="/Pune-to-Outstation-Cabs" element={<PuneToOutstationCabs />} />
<Route path="/pune-to-mahabaleshwar-cab-service" element={<Punetomahabaleshwarcab />} />
<Route path="/pune-to-lonavala-cab-service" element={<Punetolonavalacab />} />
<Route path="/pune-to-matheran-cab-service" element={<Punetomatherancabs />} />
<Route path="/pune-to-5-jyotirlinga-cab-service" element={<Punetofivejyotilingadarshan />} />
<Route path="/pune-to-bhimashankar-cab-service" element={<Punetobhimashankarcabs />} />
<Route path="/Pune-to-Aurangabad-Cab-Service" element={<Punetoaurangabadcab />} />
<Route path="/Pune-to-Nashik-Cab-Service" element={<Punetonashikcabservice />} />
<Route path="/Pune-to-Kolhapur-Cab-Service" element={<Punetokolhapurcab />} />
<Route path="/Pune-to-Alibaug-Cab" element={<Punetoalibaugcab />} />
<Route path="/Pune-to-Goa-Cab-Service" element={<Punetogoacabservice />} />
<Route path="/Goa-to-Pune-Cabs" element={<Goatopunecab />} />
<Route path="/Innova-Crysta-Cab-in-Pune" element={<Innovacrystacabinpune />} />
<Route path="/Ertiga-On-Rent-in-Pune" element={<Ertigaonrentinpune />} />
<Route path="/pune-to-ashtavinayak-cab-service" element={<Punetoashtavinayakcabs />} />
<Route path="/Pune-to-Goa-Cabs" element={<Punetogoacabs />} />
<Route path="/Pune-to-Jyotirlinga-Darshan-Package" element={<Punetojyotilingadarshanpackage />} />
<Route path="/Pune-to-Akkalkot-Cabs" element={<Punetoakkalkotcabs />} />
<Route path="/Pune-to-Pandharpur-Cab" element={<Punetopandharpurcab />} />
<Route path="/Pune-to-Grishneshwar-Jyotirlinga-Cab" element={<Punetogrishneshwarjyotilingacab />} />
<Route path="/pune-to-mumbai-cab-service" element={<Punetomumbaicabs />} />
<Route path="/Innova-Crysta-On-Rent-in-Pune" element={<Innovacrystaonrentinpune />} />
<Route path="/Ertiga-Hire-in-Pune" element={<Ertigahireinpune />} />
<Route path="/Pune-to-Shrivardhan-Cab" element={<Punetoshrivardhancab />} />
<Route path="/Pune-to-Jyotiba-Cab" element={<Punetojyotibacab />} />
<Route path="/Pune-to-Shirdi-Cab" element={<Punetoshirdicab />} />
<Route path="/Sedan-Cab-Service" element={<Sedanacabservice />} />
<Route path="/Hyundai-Xcent-Cabs-in-Pune" element={<Hydundaixcentcabinpune />} />
<Route path="/Swift-Dzire-On-Rent-in-Pune" element={<Swiftdzireonrentinpune />} />
<Route path="/Aura-Cab-Service-in-Pune" element={<Auracabserviceinpune />} />
<Route path="/Pune-Darshan-Sedan-Cab-Booking" element={<Punedarshansedancabbooking />} />
<Route path="/Pune-to-Ayodhya-Tour-Package" element={<Punetoayodhyatourpackage />} />
<Route path="/Pune-to-Mahabaleshwar-Sedan-Cab" element={<Punetomahabaleshwarcabsedan />} />
<Route path="/Pune-Airport-Cab-Sedan-Service" element={<Puneairportcabsedanservice />} />


<Route path="/Pune-to-Shirdi-Sedan-Cabs" element={<Punetoshirdisedancab />} />
<Route path="/Sedan-Cab-Booking-Pune" element={<Sedancabbookingpune />} />
<Route path="/Pune-Hyundai-Aura-Cab" element={<Punehyundaiauracab />} />
<Route path="/Pune-to-Lonavala-Sedan-Cabs" element={<Punetolonavalasedancab />} />
<Route path="/Online-Sedan-Cab-Booking-Pune" element={<Onlinesedancabbookingpune />} />
<Route path="/Pune-to-Vidarbha-Cab-Service" element={<Punetovidarbhacabservice />} />
<Route path="/Pune-to-Hyderabad-Cab" element={<Punetohyderabadcab />} />
<Route path="/Pune-to-Ujjain-Cab" element={<Punetoujjaincab />} />
<Route path="/Corporate-Cab-Service-Pune" element={<Corporatecabservicepune />} />
<Route path="/Pune-Railway-Station-Cab-Service" element={<Punerailwaystationcabservice />} />
<Route path="/Cheap-Cab-Service-in-Pune" element={<Cheapcabserviceinpune />} />
<Route path="/Online-Cab-Booking-Pune" element={<Onlinecabbookinpune />} />
<Route path="/Pune-to-Bangalore-Cab" element={<Punetobanglorecab />} />
<Route path="/Pune-to-Gujarat-Cab-Service" element={<Punetogujratcabservice />} />
<Route path="/Pune-to-Nagpur-Cab" element={<Punetonagpurcab />} />
<Route path="/Pune-to-Ahmednagar-Cab" element={<Punetoahmednagar />} />
<Route path="/Pune-to-Latur-Cab" element={<Punetolaturcab />} />
<Route path="/pune-to-mumbai-darshan-cab-service" element={<Punetomumbaidarshanca />} />
<Route path="/Pune-to-Satara-Cab" element={<Punetosataracab />} />
<Route path="/Pune-to-Sangli-Cab" element={<Punetosanglicab />} />
<Route path="/pune-to-solapur-cab-service" element={<Punetosolapurcab />} />
<Route path="/Pune-Airport-Cab" element={<Puneairportcab />} />
<Route path="/Pune-to-Rajasthan-Cab" element={<Punetorajshthancab />} />
<Route path="/Pune-to-Sambhajinagar-Cab" element={<Punetosambhajinagarcab />} />
<Route path="/Pune-to-Dhule-Cab" element={<Punetodhukecab />} />
<Route path="/Pune-to-Jalna-Cab" element={<Punetojalnacab />} />
<Route path="/Pune-to-Telangana-Cab" element={<Punetotelganacab />} />
<Route path="/Pune-to-Indore-Cab" element={<Punetoindorecab />} />

<Route path="/Pune-Taxi-Service" element={<Punetaxiservice />} />
<Route path="/Best-Cab-Service-in-Pune" element={<Bestcabserviceinpune />} />
<Route path="/Pune-One-Way-Cab-Service" element={<Puneonewaycabservice />} />
<Route path="/Pune-Local-and-Outstation-Cab" element={<Punelocalandoutstioncab />} />
<Route path="/Pune-to-Jalgaon-Cab-Service" element={<Punetojalgaoncab />} />
<Route path="/Pune-to-Thane-Cab" element={<Punetothanecab />} />
<Route path="/Pune-to-Panvel-Cabs" element={<Punetopanvelcabs />} />
<Route path="/Pune-to-Nanded-Cab-Service" element={<Punetonandedcabservice />} />
<Route path="/Pune-to-Surat-Cab" element={<Punetosuracab />} />
<Route path="/Pune-to-Ahmedabad-Cab" element={<Punetoahmedabadcab />} />
<Route path="/Pune-to-Mahabaleshwar-Taxi" element={<Punetomahabaleshwartaxi />} />
<Route path="/Pune-to-Igatpuri-Taxi" element={<Punetolgatpuritaxi />} />
<Route path="/Pune-to-Tamhini-Ghat-Cab" element={<Punetotamhinighat />} />
<Route path="/Pune-to-Trimbakeshwar-Cab-Service" element={<Punetotrimbkeshwarcab />} />
<Route path="/Pune-to-Ashtavinayak-Darshan-Cab" element={<Punetoashtavinayakdarshancab />} />
<Route path="/Pune-to-Jejuri-Cab-Service" element={<Punetojejuricab />} />
<Route path="/Pune-to-Aundha-Nagnath-Cab" element={<Punetoaundhnagnathcab />} />
<Route path="/Pune-to-Konkan-Darshan-Cab" element={<Punetokonkadarshancabn />} />
<Route path="/mumbai-airport-to-pune-cab-service" element={<Mumbaiairporttopunecab />} />
<Route path="/Mumbai-Airport-Cab-Service" element={<Mumbaiairportcabservice />} />
<Route path="/Navi-Mumbai-Airport-Cab" element={<Navimumbaiairportcab />} />
<Route path="/Cab-Service-in-Navi-Mumbai" element={<Cabserviceinnavimumbai />} />
<Route path="/Innova-Crysta-On-Rent-in-Mumbai" element={<Innovacrystaonrentinmumbai />} />
<Route path="/Ertiga-On-Rent-in-Mumbai" element={<Ertigaonrentinmumbai />} />
<Route path="/Mumbai-to-Mahabaleshwar-Cab" element={<Mumbaitomahabaleshwarcab />} />
<Route path="/Cab-Service-in-Thane" element={<Cabserviceithene />} />
<Route path="/Mumbai-to-Goa-Cab" element={<Mumbaitogoacab />} />
<Route path="/Cab-Service-in-Pimpri-Chinchwad" element={<Cabserviceinpimprichichwad />} />
<Route path="/Pune-Innova-Cabs" element={<Puneinnovacabs />} />
<Route path="/Best-Outstation-Cab-Service-in-Pune" element={<Bestoutstationcabservice />} />
<Route path="/Pune-to-Panchgani-Cabs" element={<Punetopanchganicab />} />
<Route path="/Hinjewadi-Cab-Service" element={<Hinjewadicabservice />} />
<Route path="/Navi-Mumbai-International-Airport-Cabs" element={<Navimumbaiinternatinalairport />} />
<Route path="/Cab-Service-in-Kharadi" element={<Cabserviceinkharadi />} />
<Route path="/Cab-Service-in-Wagholi" element={<Cabserviceinwagholi />} />
<Route path="/Cab-Service-in-Mundhwa" element={<Cabserviceinmundhwa />} />
<Route path="/Cab-Service-in-Kalyani-Nagar" element={<Cabserviceinkalyaninagar />} />
<Route path="/Cab-Service-in-Kothrud" element={<Cabserviceinkothrud />} />
      </Routes>



      <Footer />
    </Router>
  );
}

export default App;
